import React, { useState, useEffect } from "react";
import {
  initialNodeStyle,
  initialDirectedWeightedEdgeStyle,
  visitedDirectedWeightedEdgeStyle,
} from "./FlowGraphStyle";
import { min } from "d3";
const EdmonKarps = ({
  cytoscape,
  adjacencyList,
  edgeWeights,
  sourceNode,
  sinkNode,
}) => {
  const [totalFlow, setTotalFlow] = useState(0);
  const [originalEdgeWeights, setOriginalEdgeWeights] = useState({});
  const [edgeWeights1, setEdgeWeights] = useState({ ...edgeWeights });
  const [selectedPaths, setSelectedPaths] = useState([]);
  const [selectedPathFlows, setSelectedPathFlows] = useState([]);
  const [currentAction, setCurrentAction] = useState("Find Augmenting Path");
  const [isAugmentingPathFound, setIsAugmentingPathFound] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  //let newParent = {}; // Initialize parent object
  const [newParent, setNewParent] = useState({});
  // let updatedParent = null; // Initialize updatedParent to null
  const [updatedParent, setUpdatedParent] = useState(null);
  const handleButtonClick = async () => {
    if (isAnimating) return;
    setIsAnimating(true);

    if (currentAction === "Find Augmenting Path") {
      // Find augmenting path
      let [found, updatedParentFromBFS] = bfs(
        adjacencyList,
        sourceNode,
        sinkNode,
        newParent
      );
      // console.log("updatedParentfromBFS", updatedParentFromBFS);
      if (found) {
        // If an augmenting path is found, update action and state
        setCurrentAction("Update Edges");
        //updatedParent = updatedParentFromBFS;
        setUpdatedParent(updatedParentFromBFS);
        //console.log("upppp", updatedParent);
        setIsAugmentingPathFound(true);
      } else {
        // If no more augmenting paths can be found, reset action and state
        setCurrentAction("Reset Animation");
      }
    } else if (currentAction === "Update Edges") {
      // Update edges
      if (updatedParent !== null) {
        // Check if an augmenting path was found
        //console.log("updated", updatedParent);
        let flow = augmentingPath(true, updatedParent); // Pass found=true and updatedParent
        let newTotalFlow = totalFlow + flow;
        setTotalFlow(newTotalFlow);
        //setSelectedPathFlows((prevFlows) => [...prevFlows, flow]);
      }
      setCurrentAction("Find Augmenting Path");
      setIsAugmentingPathFound(false);
    } else if (currentAction === "Reset Animation") {
      // Reset animation
      resetAnimation();
      setCurrentAction("Find Augmenting Path");
    }

    setIsAnimating(false);
  };

  useEffect(() => {
    // Store the original edge weights when the component mounts
    setOriginalEdgeWeights({ ...edgeWeights });
  }, []);

  const bfs = (graph, source, target, parent) => {
    cytoscape.elements("edge").style(initialDirectedWeightedEdgeStyle);
    let visited = new Set(); // Set to track visited nodes
    let queue = []; // Queue to store nodes to visit
    queue.push(source); // Enqueue the source node
    let newParent = { ...parent };
    while (queue.length > 0) {
      let current = queue.shift(); // Dequeue a node from the queue

      // If the current node is the target node, return true and the parent object
      if (current === target) {
        let newPath = [];
        let node = target;
        while (node !== source) {
          newPath.unshift(node);
          node = newParent[node];
        }
        newPath.unshift(source);

        setSelectedPaths((prevPaths) => [...prevPaths, newPath]);
        //console.log("true");
        //console.log("new", newParent);
        return [true, newParent];
      }

      // Mark the current node as visited
      visited.add(current);
      let currentNode = cytoscape.getElementById(current);
      if (graph[current] == undefined) {
        continue;
      }
      let neighbors = graph[current].sort();

      // Iterate through the neighbors of the current node
      for (let neighbor of neighbors) {
        // If the neighbor has not been visited and there is available capacity
        if (
          !visited.has(neighbor) &&
          edgeWeights1[`${current}-${neighbor}`] > 0
        ) {
          // Add the neighbor to the queue
          queue.push(neighbor);

          let sourceId = current === "S" ? current : `node${current}`;
          let targetId = neighbor === "T" ? neighbor : `node${neighbor}`;
          let selectedEdges = cytoscape.edges(
            `[source='${sourceId}'][target='${targetId}']`
          );
          //selectedEdges.style(visitedDirectedWeightedEdgeStyle);

          // Set the parent of the neighbor node
          newParent[neighbor] = current;
        }
      }
    }

    // If the target node is not reached, return false and the parent object
    return [false, newParent];
  };

  const augmentingPath = (found, newParent) => {
    // Initialize parent object
    //let parent = {};
    // Find an augmenting path using BFS

    //let [found, newParent] = bfs(adjacencyList, sourceNode, sinkNode, parent);
    // If an augmenting path is found
    if (found) {
      //console.log(found);
      let current = sinkNode;
      let minFlow = Infinity;

      // Find the minimum flow along the augmenting path
      while (current !== sourceNode) {
        let prev = newParent[current];
        let edgeId = `${prev}-${current}`;
        minFlow = Math.min(minFlow, edgeWeights1[edgeId]);
        //console.log(minFlow);
        current = prev;
      }

      // Update the edge weights along the augmenting path
      current = sinkNode;
      while (current !== sourceNode) {
        let prev = newParent[current];
        let edgeId = `${prev}-${current}`;
        let backEdgeId = `${current}-${prev}`;
        edgeWeights1[edgeId] -= minFlow;
        edgeWeights1[backEdgeId] = minFlow;
        //console.log("eeeee", edgeWeights1[backEdgeId]);
        //console.log("backedge", backEdgeId);
        let sourceId = prev === "S" ? prev : `node${prev}`;
        let targetId = current === "T" ? current : `node${current}`;
        // console.log(sourceId + " " + targetId);
        let selectedEdges = cytoscape.edges(
          `[source='${sourceId}'][target='${targetId}']`
        );
        selectedEdges.data("weight", edgeWeights1[edgeId]);
        selectedEdges.style(visitedDirectedWeightedEdgeStyle);
        let selectedBackEdge = cytoscape.edges(
          `[source='${targetId}'][target='${sourceId}']`
        );
        selectedBackEdge.data("weight", edgeWeights1[backEdgeId]);
        selectedBackEdge.style(visitedDirectedWeightedEdgeStyle);

        //console.log(selectedBackEdge);
        current = prev;
      }
      setSelectedPathFlows((prevFlows) => [...prevFlows, minFlow]);
      // Return the minimum flow
      return minFlow;
    }
    // If no augmenting path is found, return 0
    return 0;
  };

  const resetAnimation = () => {
    for (const edgeId in originalEdgeWeights) {
      const [source, target] = edgeId.split("-");
      let sourceId = source === "S" ? source : `node${source}`;
      let targetId = target === "T" ? target : `node${target}`;
      const selectedEdges = cytoscape.edges(
        `[source='${sourceId}'][target='${targetId}']`
      );
      const backEdges = cytoscape.edges(
        `[source='${targetId}'][target='${sourceId}']`
      );
      // console.log(originalEdgeWeights);
      if (selectedEdges.nonempty()) {
        selectedEdges.data("weight", originalEdgeWeights[edgeId]);
        backEdges.data("weight", 0);
        backEdges.style(initialDirectedWeightedEdgeStyle);
        selectedEdges.style(initialDirectedWeightedEdgeStyle);
      }
    }
    cytoscape.elements("node").style(initialNodeStyle);

    // cytoscape.elements("edge").style(initialDirectedWeightedEdgeStyle);
    setTotalFlow(0);
    setNewParent({});
    setUpdatedParent(null);
    //setOriginalEdgeWeights({ ...originalEdgeWeights });
    setSelectedPaths([]);
    setSelectedPathFlows([]);
    setCurrentAction("Find Augmenting Path");
    setEdgeWeights({ ...originalEdgeWeights });
  };

  return (
    <div className="topological-sort-container">
      <div className="topological-sort-buttons" style={{ marginTop: "2%" }}>
        <button
          className="animate-reset-button"
          onClick={handleButtonClick}
          disabled={isAnimating}
        >
          {currentAction === "Find Augmenting Path"
            ? "Find Augmenting Path"
            : currentAction === "Update Edges"
            ? "Update Edges"
            : "Reset Animation"}
        </button>
        &nbsp;&nbsp; &nbsp;&nbsp;
        <button
          className="animate-reset-button"
          onClick={resetAnimation}
          disabled={isAnimating}
        >
          Start Over
        </button>
        <div className="queue-title" style={{ marginTop: "2%" }}>
          Total Flow: {totalFlow}
        </div>
        {/*<div>
          Selected Path (s):{" "}
          {selectedPaths.map((path, index) => (
            <div key={index}>
              Path {index + 1}: {path.join(" -> ")}
            </div>
          ))}
          </div>*/}
        <div className="table-container" style={{ marginTop: "2%" }}>
          <table className="custom-table">
            <thead>
              <tr>
                <th>Selected Path</th>
                <th>Minimum Flow</th>
              </tr>
            </thead>
            <tbody>
              {selectedPaths.map((path, index) => (
                <tr key={index}>
                  <td>
                    Path {index + 1}: {path.join(" -> ")}
                  </td>
                  <td>{selectedPathFlows[index]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {currentAction === "Reset Animation" && !isAugmentingPathFound && (
          <div className="queue-title" style={{ marginTop: "2%" }}>
            No more augmenting paths found.
          </div>
        )}
      </div>
    </div>
  );
};

export default EdmonKarps;
